import { render, staticRenderFns } from "./ToggleColumnModal.vue?vue&type=template&id=63b636bf&scoped=true"
import script from "./ToggleColumnModal.vue?vue&type=script&lang=js"
export * from "./ToggleColumnModal.vue?vue&type=script&lang=js"
import style0 from "./ToggleColumnModal.vue?vue&type=style&index=0&id=63b636bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b636bf",
  null
  
)

export default component.exports